import styled, { css } from 'styled-components';
import { Scrollbar } from '../Scrollbar';

const transparent20 = 'rgba(0, 0, 0, 0.23)';

export const LabelBackground = styled.div`
  position: absolute;
  width: 100%;
  height: 50%;
  bottom: 0;
  left: 0;
  z-index: -1;
`;

export const Label = styled.span<{ atTop?: boolean; disabled?: boolean }>`
  transition: color 0.1s ease;
  position: absolute;
  color: ${({ theme }) => theme.colors.textGrey};
  font-size: ${({ atTop }) => (atTop ? '12px' : '13px')};
  transform: ${({ atTop }) =>
    atTop ? 'translateY(-13px)' : 'translateY(12px)'};
  padding: 0 8px;
  left: 0.5rem;
  transition: transform 0.1s, font-size 0.1s;

  & > ${LabelBackground} {
    background-color: ${({ disabled, theme, atTop }) => {
      if (!atTop) return 'transparent';
      return disabled ? theme.colors.lightestGray : theme.colors.white;
    }};
  }
`;

export const TextAreaWrapper = styled.label<{ $active: boolean }>`
  display: flex;
  border-style: solid;
  border-width: 1px;
  border-radius: 1px;
  border-color: ${({ $active, theme }) =>
    $active ? theme.colors.lightBlue : theme.colors.lightGrey};
  transition: border-color 0.1s;
  box-sizing: border-box;
  line-height: 1.1875em;
  padding: 1px;
  position: relative;

  &:hover {
    border-color: ${({ $active, theme }) =>
      $active ? theme.colors.lightBlue : theme.colors.textGrey};
  }

  &:focus-within {
    border-color: ${({ theme }) => theme.colors.lightBlue};
  }

  &:focus-within ${Label} {
    font-size: 12px;
    transform: translateY(-13px);
  }
`;

export const TextAreaField = styled.textarea<{
  disabled?: boolean;
  readOnly?: boolean;
}>`
  padding: 12px 15px;
  font-family: NLRTM, sans-serif;
  font-size: 14px;
  width: 100%;
  color: ${({ theme }) => theme.colors.darkBlue};
  transition: color 0.1s;
  text-overflow: ellipsis;

  box-sizing: content-box;
  background-color: transparent;
  outline: 0;
  border: 0;
  resize: none;
  cursor: ${({ disabled, readOnly }) => {
    if (!disabled) return readOnly ? 'pointer' : 'text';
    return 'default';
  }};

  ${Scrollbar.secondary};

  &:hover {
    color: ${({ theme }) => theme.colors.darkBlue};
  }
`;

export const Container = styled.div<{ disabled?: boolean; hasError: boolean }>`
  position: relative;
  background-color: ${({ disabled, theme }) =>
    disabled ? theme.colors.lightestGray : undefined};

  & > ${TextAreaWrapper} {
    border-color: ${({ disabled }) => (disabled ? transparent20 : null)};
  }

  ${({ theme, hasError }) =>
    hasError &&
    css`
      & ${TextAreaWrapper} {
        border-color: ${theme.colors.red};
      }

      & ${Label} {
        color: ${theme.colors.red};
      }
    `}
`;

export const Prefix = styled.div``;
export const Postfix = styled.div`
  display: flex;
  align-items: center;
  font-size: 0.8rem;
  color: ${({ theme }) => theme.colors.textGrey};
  margin-right: 0.5rem;
`;
